import React from "react";
import "./merchandiseItem.css";
import DOMPurify from "dompurify";
const MerchandiseItem = ({ image, label, desc, arrowIcon, onClick }) => {
  function createMarkup(html) {
    return {
      __html: DOMPurify.sanitize(html),
    };
  }
  return (
    <div className="category_header">
      <img className="category_icon" src={image} alt="category"></img>
      <div className="category_text">
        <div className="category_title boldFont">{label}</div>
        {/* {label && (
          <div
            className="category-sub-title mediumFont"
            dangerouslySetInnerHTML={createMarkup(desc)}
          ></div>
        )} */}
      </div>
      <img
        className="arrow_down"
        src={arrowIcon}
        onClick={onClick}
        alt="arrow"
      ></img>
    </div>
  );
};

export default MerchandiseItem;
